import React from 'react'

const CHartStatsNavigation = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        columnGap: '10px'
      }}
    >
      <div
        // onClick={() => setFiltersMode('options')}
        style={{
          backgroundColor: '#0085FF',
          display: 'flex',
          width: '100%',
          borderRadius: '7px',
          padding: '10px',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            color: 'white',
            fontFamily: ' Roboto, sans-serif',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '100%',
          }}
        >
          Play This Chart
        </div>
      </div>
      <div
        // onClick={() => setFiltersMode('reports')}
        style={{
          backgroundColor: '#0085FF',
          display: 'flex',
          width: '100%',
          borderRadius: '7px',
          padding: '10px',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            color: 'white',
            fontFamily: ' Roboto, sans-serif',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '100%',
          }}
        >
          Fix My Mistakes
        </div>
      </div>
    </div>
  )
}

export default CHartStatsNavigation
